import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/brand/logo.png';
import UserLogo from '../../assets/header-icons/user-logo.png';
import searchLogo from '../../assets/header-icons/search.png';
import notificationLogo from '../../assets/header-icons/notification-bell.png';
import { MoreVert } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { headerLinks } from '../../constant/headerLinks';
import { ClickAwayListener } from '@mui/material';
import DrawerComp from './drawer';
import './header.scss';

const HeaderNew = () => {
    const [activeDropDown, setActiveDropDown] = useState<string>('');
    const [activeLink, setActiveLink] = useState<string>('home');
    const [hideDropDown, setHideDropDown] = useState<boolean>(false);
    const [toggleSearchBar, setToggleSearchBar] = useState(false);
    const [openDrawer, setOpenDrawer] = useState<{ isOpen: boolean, position: string, showData: string }>({ isOpen: false, position: 'left', showData: '' });

    // for active link color and show dropdown
    const handleClick = (name: string) => {
        setActiveLink(name);
        setHideDropDown(true);
    }

    // for active dropdown link color and hide dropdown
    const handleClose = (name: string) => {
        setActiveDropDown(name);
        setHideDropDown(false);
    };

    // for hide dropdown when click we click on anywhere on screen
    const handleClickAway = () => {
        setHideDropDown(false);
    }

    return (

        <div>
            <ClickAwayListener onClickAway={handleClickAway}>
                <div className="header-wrapper">
                    <header className="header flex-center-between flex-wrap">
                        <div className="menu-icon-wrapper">
                            <MenuIcon className='menu-bar-icon cursor-pointer' onClick={() => setOpenDrawer({ isOpen: true, position: 'left', showData: 'menu' })} />
                        </div>
                        <div className="logo cursor-pointer">
                            <Link to='/'><img src={Logo} alt='logo' /></Link>
                        </div>
                        <div className="header-link-container">
                            <ul className="header-link-ul flex-center-center flex-wrap">
                                {
                                    headerLinks.map(({ id, name, icon, subMenu }) => <li key={id} className="header-link-li">
                                        <Link to={name === 'home' ? '/' : '#'} style={{ backgroundColor: name === activeLink ? "#F0F0F0" : '' }} className="header-link flex-center-center flex-column" onClick={() => handleClick(name)}>
                                            <div className="header-img-wrapper">
                                                <img src={icon} className='header-link-img' />
                                            </div>
                                            <span className={`header-link-text ${name === activeLink ? 'active-link' : 'default-link'}`}>{name}</span>
                                        </Link>
                                        {
                                            hideDropDown && (name === activeLink && name !== 'home') && <div className="drop-down-box">
                                                {subMenu && subMenu?.map(({ id, heading, links, singleName, singlePath }) => <div key={id}>

                                                    {(name === 'growth' && singleName === 'survey') && <p className='drop-down-li'><Link className={`drop-down-link d-block br-4 text-capitalize ${activeDropDown === singleName ? 'active-child' : ''}`} onClick={() => handleClose(singleName)} to={singlePath}>{singleName}</Link></p>}

                                                    {heading && <p className='text-capitalize heading fw-600'>{heading}</p>}

                                                    <ul className='drop-down-sec'>
                                                        {links?.map(({ id, name, path }) => (<li className='drop-down-li' key={id}><Link className={`drop-down-link d-block br-4 text-capitalize ${activeDropDown === name ? 'active-child' : ''}`} onClick={() => handleClose(name)} to={path}>{name}</Link></li>))}
                                                    </ul>

                                                    {(name === 'growth' && singleName === '1-on-1s') && <p className='drop-down-li'><Link className={`drop-down-link d-block br-4 ${activeDropDown === singleName ? 'active-child' : ''}`} onClick={() => handleClose(singleName)} to={singlePath}>{singleName}</Link></p>}

                                                </div>
                                                )}
                                            </div>
                                        }
                                    </li>)
                                }
                            </ul>
                        </div>
                        <div>
                            <div className="user-sec d-flex align-center justify-end">
                                <div className='d-flex align-center search-input'>
                                    <input type="text" className={`input ${toggleSearchBar ? 'active' : ''}`} placeholder='Search...' />
                                    <img src={searchLogo} alt='search' className='cursor-pointer' onClick={() => { setToggleSearchBar(!toggleSearchBar); setHideDropDown(false) }} />
                                    {/* this span is working on condition */}
                                    <span className={` input-backdrop ${toggleSearchBar ? 'active-input' : 'inactive-input'}`}></span>
                                </div>
                                <div className="notification-box cursor-pointer">
                                    <img src={notificationLogo} alt='notification' onClick={() => setOpenDrawer({ isOpen: true, position: 'right', showData: 'notification' })} />
                                </div>
                                <div className="user-logo cursor-pointer">
                                    <img src={UserLogo} alt='user' onClick={() => setOpenDrawer({ isOpen: true, position: 'right', showData: 'user-info' })} />
                                </div>
                            </div>
                            <MoreVert className='more-icon cursor-pointer' />
                        </div>
                    </header>
                </div>
            </ClickAwayListener>
            {/* drawer component */}
            <DrawerComp openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
        </div>

    )
}

export default HeaderNew